var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-block text-justify"})
}
var staticRenderFns = []

export { render, staticRenderFns }